import React from "react";

export const MenuDivider: React.FC = () => {
  return <li role="separator" className="fs-menu__divider" />;
};
